import React from 'react';
import { Button } from '@/components/ui/button';
import { Trophy } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';

const ApplicantProfileModal = ({
  profileDialog,
  setProfileDialog,
  getStatusBadge
}) => {
  return (
    <Dialog open={profileDialog.open} onOpenChange={(open) => !open && setProfileDialog({ open: false, applicant: null })}>
      <DialogContent className="max-w-2xl max-h-[80vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Applicant Profile</DialogTitle>
        </DialogHeader>
        
        {profileDialog.applicant && (
          <div className="space-y-6 py-4">
            <div className="flex items-center gap-4 border-b border-slate-200 pb-6">
              <div className="w-16 h-16 bg-greek-blue/10 rounded-full flex items-center justify-center text-xl text-greek-blue font-bold">
                {profileDialog.applicant.first_name?.[0]}{profileDialog.applicant.last_name?.[0]}
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900">
                  {profileDialog.applicant.first_name} {profileDialog.applicant.last_name}
                </h3>
                <p className="text-slate-500">{profileDialog.applicant.email}</p>
                <p className="text-sm text-slate-400 mt-1">
                  Joined: {new Date(profileDialog.applicant.created_at).toLocaleDateString()}
                </p>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold text-slate-900 mb-4 flex items-center gap-2">
                <Trophy className="w-5 h-5 text-greek-gold" />
                Application History
              </h4>
              
              {profileDialog.applicant.applications?.length === 0 ? (
                <p className="text-slate-500 text-sm">No applications found.</p>
              ) : (
                <div className="space-y-3">
                  {profileDialog.applicant.applications?.map(app => (
                    <div key={app.id} className="bg-slate-50 border border-slate-200 rounded-lg p-4">
                      <div className="flex items-start justify-between">
                        <div>
                          <h5 className="font-medium text-slate-900">{app.scholarship_name}</h5>
                          <div className="flex items-center gap-3 mt-1 text-sm text-slate-500">
                            <span>Started: {new Date(app.created_at).toLocaleDateString()}</span>
                            {app.submitted_at && (
                              <span>Submitted: {new Date(app.submitted_at).toLocaleDateString()}</span>
                            )}
                          </div>
                        </div>
                        <div className="flex flex-col items-end gap-2">
                          <span className={`px-2 py-0.5 rounded-full text-xs ${getStatusBadge(app.status)}`}>
                            {app.status?.replace('_', ' ').charAt(0).toUpperCase() + app.status?.slice(1).replace('_', ' ')}
                          </span>
                          {app.is_archived && (
                            <span className="px-2 py-0.5 rounded-full text-xs bg-slate-200 text-slate-500">
                              Archived
                            </span>
                          )}
                        </div>
                      </div>
                      
                      {app.status === 'awarded' && app.award_details && (
                        <div className="mt-3 pt-3 border-t border-slate-200">
                          <p className="text-sm text-green-700 font-medium flex items-center gap-1">
                            <Trophy className="w-4 h-4" />
                            Awarded: ${app.award_details.amount?.toLocaleString()}
                          </p>
                          <p className="text-xs text-slate-500 mt-1">
                            Award Year: {app.award_details.award_year}
                          </p>
                          {app.award_details.notes && (
                            <p className="text-sm text-slate-600 mt-2 bg-white p-2 rounded border border-slate-100">
                              {app.award_details.notes}
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
        
        <DialogFooter>
          <Button variant="outline" onClick={() => setProfileDialog({ open: false, applicant: null })}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ApplicantProfileModal;